import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

const AuthTimerTester = () => {
  const [timeRemaining, setTimeRemaining] = useState(30 * 60); // 30 minutes in seconds
  const [isRunning, setIsRunning] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const { logout, refreshToken } = useContext(AuthContext);

  useEffect(() => {
    let interval;
    if (isRunning && timeRemaining > 0) {
      interval = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime === 5 * 60) { // 5 minutes remaining
            setShowWarning(true);
          }
          return prevTime - 1;
        });
      }, 10); // Update every 10ms to simulate faster time
    } else if (timeRemaining === 0) {
      handleSessionExpired();
    }
    return () => clearInterval(interval);
  }, [isRunning, timeRemaining]);

  const handleStart = () => {
    setIsRunning(true);
  };

  const handlePause = () => {
    setIsRunning(false);
  };

  const handleReset = () => {
    setIsRunning(false);
    setTimeRemaining(30 * 60);
    setShowWarning(false);
  };

  const handleExtendSession = () => {
    refreshToken();
    setTimeRemaining(30 * 60);
    setShowWarning(false);
  };

  const handleSessionExpired = () => {
    setIsRunning(false);
    logout();
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  return (
    <div className="auth-timer-tester">
      <h2>Auth Timer Tester</h2>
      <div className="timer-display">Time Remaining: {formatTime(timeRemaining)}</div>
      <div className="controls">
        <button onClick={handleStart} disabled={isRunning}>Start</button>
        <button onClick={handlePause} disabled={!isRunning}>Pause</button>
        <button onClick={handleReset}>Reset</button>
        <button onClick={() => setTimeRemaining(5 * 60)}>Set to 5 minutes</button>
      </div>
      {showWarning && (
        <div className="warning-dialog">
          <p>Your session will expire in 5 minutes. Do you want to extend it?</p>
          <button onClick={handleExtendSession}>Extend Session</button>
        </div>
      )}
    </div>
  );
};

export default AuthTimerTester;